module.exports = __webpack_public_path__ + "static/media/gazeta92.049dc5de.jpg";